import type { CareColorKey } from '@/types/care'

/**
 * The Consultation Builder's section palette, resolved to the hexes the care timeline draws in.
 *
 * Sections already carry one of these keys (`consultation/src/types/section.ts`), so a section
 * authored as `rose` is the same colour in the builder, in the chart and on its table row — the
 * colour is part of the definition rather than an index into whatever order the series arrive in.
 */
export const CARE_COLORS: Record<CareColorKey, string> = {
  // `teal`, `green` and `cyan` are three neighbours in one hue family, and a menopause module uses
  // all three at once. They are pulled apart by lightness as well as hue — deep blue-teal, mid
  // emerald, bright cyan — so the six lines stay tellable apart at line weight, where picking three
  // pleasant greens would leave them indistinguishable.
  teal: '#0E7490',
  purple: '#B84DE0',
  amber: '#F5A524',
  rose: '#EC4899',
  green: '#10B981',
  cyan: '#22D3EE',
  orange: '#F97316',
  slate: '#64748B'
}

/** Prescription dividers and their axis labels — one colour for both kinds, the dash tells them apart. */
export const CARE_RX_COLOR = '#6D4AFF'

export const careColor = (key: CareColorKey) => CARE_COLORS[key] ?? CARE_COLORS.slate
